import React from 'react';

const StockSummaryPrint = ({ data }: { data: any }) => {
  return (
    <div className="font-sans text-[12px] text-black bg-white p-8 max-w-4xl mx-auto">
      <div className="text-center font-bold text-xl uppercase tracking-wider border-b-2 border-black pb-4 mb-4">
        {data.company.name}
      </div>
      <div className="text-center font-bold text-lg mb-2">Stock Summary</div>
      <div className="text-center mb-6 text-sm">As of {data.reportMeta.toDate}</div>

      <table className="w-full border-collapse border border-gray-400 mb-8">
        <thead>
          <tr className="bg-gray-100">
            <th className="border border-gray-400 p-2 text-left w-1/2">Particulars</th>
            <th className="border border-gray-400 p-2 text-right">Quantity</th>
            <th className="border border-gray-400 p-2 text-right">Avg. Rate</th>
            <th className="border border-gray-400 p-2 text-right">Value</th>
          </tr>
        </thead>
        <tbody>
          {data.items.map((item: any, idx: number) => (
            <tr key={idx}>
              <td className="border border-gray-400 p-2 text-left">
                <span style={{ paddingLeft: `${item.depth * 1}rem` }}>
                  {item.name}
                </span>
              </td>
              <td className="border border-gray-400 p-2 text-right">{item.quantity}</td>
              <td className="border border-gray-400 p-2 text-right">{item.rate ? item.rate.toFixed(2) : ''}</td>
              <td className="border border-gray-400 p-2 text-right font-semibold">{item.value ? item.value.toFixed(2) : ''}</td>
            </tr>
          ))}
          <tr className="bg-gray-100 font-bold border-t-2 border-black">
            <td className="border border-gray-400 p-2 text-right">Total</td>
            <td className="border border-gray-400 p-2 text-right">{data.totals.quantity}</td>
            <td className="border border-gray-400 p-2 text-right"></td>
            <td className="border border-gray-400 p-2 text-right">{data.totals.value}</td>
          </tr>
        </tbody>
      </table>
      
      <div className="text-center text-[10px] text-gray-500 mt-8 space-y-1 border-t border-gray-300 pt-4">
        <p>This is a computer-generated summary.</p>
        <p>Subject to Mumbai Jurisdiction.</p>
      </div>
    </div>
  );
};

export default StockSummaryPrint;
